/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRoleSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteRoleRequest = {
  /**
   * The ID of the role to delete.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteRoleSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteRoleSecurity$outboundSchema: z.ZodMiniType<
  DeleteRoleSecurity$Outbound,
  DeleteRoleSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteRoleSecurityToJSON(
  deleteRoleSecurity: DeleteRoleSecurity,
): string {
  return JSON.stringify(
    DeleteRoleSecurity$outboundSchema.parse(deleteRoleSecurity),
  );
}

/** @internal */
export type DeleteRoleRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteRoleRequest$outboundSchema: z.ZodMiniType<
  DeleteRoleRequest$Outbound,
  DeleteRoleRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteRoleRequestToJSON(
  deleteRoleRequest: DeleteRoleRequest,
): string {
  return JSON.stringify(
    DeleteRoleRequest$outboundSchema.parse(deleteRoleRequest),
  );
}
